<script>
import { mapState } from 'vuex'
import { Icon } from 'buefy/dist/components/icon'
import { Tooltip } from 'buefy/dist/components/tooltip'
import { Tag } from 'buefy/dist/components/tag'

export default {
    name : "Timer",
    components : {
        'b-icon' : Icon,
        'b-tag' : Tag,
        'b-tooltip' : Tooltip,
    },
    props : {
        dueDate : Number
    },
    data(){
        return {
            // dueDate : new Date('May 17, 2020 09:19:00').getTime(), -- for testing
            start : null,
            end : null,
            months : 0,
            weeks : 0,
            days : 0,
            hours : 0,
            minutes : 0,
            seconds : 0,
            str : ''
        }
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        deadlineMsg() {
            var msg = 'No time remaining'
            if (this.profile && !this.profile.role.match(/admin/gi)) {
                msg += '. Please submit your entry'
            }
            msg += '.'
            return msg
        },
        readableDueDate(){
            if (this.dueDate) {
                return 'Deadline: '+this.$moment(this.dueDate,'x').format('lll');
            }
            return '';
        },
        passedDue(){
            if (this.months==0 && this.weeks==0 && this.days==0 && 
                this.hours==0 && this.minutes==0 && this.seconds==0) {
                return true;
            }
            return false;
        },
        moLabel(){
            let label = 'month';
            if (this.months > 1) {
                return label+'s';
            }
            return label;
        },
        wkLabel(){
            let label = 'week';
            if (this.weeks > 1) {
                return label+'s';
            }
            return label;
        },
        dayLabel(){
            let label = 'day';
            if (this.days > 1) {
                return label+'s';
            }
            return label;
        },
        hrLabel(){
            let label = 'hour';
            if (this.hours > 1) {
                return label+'s';
            }
            return label;
        },
        minLabel(){
            let label = 'minute';
            if (this.minutes > 1) {
                return label+'s';
            }
            return label;
        },
        secLabel(){
            let label = 'second';
            if (this.seconds > 1) {
                return label+'s';
            }
            return label;
        },
    },
    created(){

    },
    mounted(){
        this.start = new Date().getTime();
        this.end = this.dueDate;
        // Update the count down every 1 second
        this.timerCount(this.start,this.end);
        this.interval = setInterval(() => {
            this.str = 'Calculating..'
            this.timerCount(this.start,this.end);
        }, 1000);
    },
    methods: {
        timerCount(start,end){
            // Get todays date and time
            var now = new Date().getTime();

            var distance = start - now;
            var passTime = end - now;

            if(distance < 0 && passTime < 0){
                clearInterval(this.interval);
                return;
            }
            else if(distance < 0 && passTime > 0){
                this.calcTime(passTime);

            } 
            else if( distance > 0 && passTime > 0 ){
                this.calcTime(distance); 
            }
        },
        calcTime(dist){
            // Time calculations
            this.months = Math.floor(dist / (1000 * 60 * 60 * 24 * 30));
            this.weeks = Math.floor(dist / (1000 * 60 * 60 * 24 * 7));
            this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
            this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
            this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
        }
    }
}
</script>

<template>
    <div>
        <b-tooltip 
            type="is-dark"
            :label="readableDueDate">

            <b-tag 
                type="is-warning" 
                size="is-medium"
                v-if="!passedDue">
                &nbsp;
                <b-icon 
                    size="is-small"
                    pack="fa"
                    icon="clock"
                    type="is-dark"></b-icon>
                <span v-if="months!=0">
                    <span class="has-text-weight-semibold">{{months}}</span> {{moLabel}}
                </span>
                <span v-if="months == 0 && weeks > 0">
                    <span class="has-text-weight-semibold">{{weeks}}</span> {{wkLabel}}
                </span> 
                <span v-if="weeks == 0 && days > 0">
                    <span class="has-text-weight-semibold">{{days}}</span> {{dayLabel}}
                </span> 
                <span v-if="days == 0">
                    <span v-if="hours > 0">
                        <span class="has-text-weight-semibold">{{hours}}</span> {{hrLabel}}
                    </span>
                    <span v-if="minutes > 0">
                        <span class="has-text-weight-semibold">{{minutes}}</span> {{minLabel}} 
                    </span>
                    <span v-if="seconds > 0">
                        <span class="has-text-weight-semibold">{{seconds}}</span> {{secLabel}} 
                    </span>
                </span>
                <span class="has-text-weight-semibold">remaining</span>
            </b-tag>

            <b-tag 
                type="is-danger" 
                size="is-medium"
                v-if="str!='' && passedDue">
                &nbsp;
                <b-icon 
                    size="is-small"
                    pack="fa"
                    icon="clock"
                    type="is-white"></b-icon>
                <span class="has-text-weight-semibold">{{deadlineMsg}}</span>
            </b-tag>
        </b-tooltip>
    </div>
</template>




// WEBPACK FOOTER //
// src/components/TimeRemaining.vue